import type { Language } from '@seek/melways-sites';

export const isLocalisedPath = ({
  language,
  path,
}: {
  language: Language;
  path: string;
}): boolean => Boolean(path.match(new RegExp(`^\/${language}(?:\/|$)`, 'i')));
